import React from 'react';
import styled from 'styled-components';
import { GridSection, Eyebrow, SectionTitle } from './GridSection';

const Section = styled(GridSection)`
  padding-bottom: 90px;
`;

const Lede = styled.p`
  font-size: 1.1rem;
  line-height: 1.7;
  color: var(--ink);
  margin: 0 0 28px;
  max-width: 560px;

  em { font-style: italic; }
`;

const Email = styled.a`
  font-family: 'EB Garamond', Georgia, serif;
  font-size: 1.45rem;
  color: var(--ink);
  border-bottom: 1px solid var(--ink);
  padding: 6px 0 4px;
  text-decoration: none;
  display: inline-block;
  overflow-wrap: anywhere;
  &:hover { color: var(--accent); border-color: var(--accent); text-decoration: none; }
`;

const Footer = styled.div`
  margin-top: 56px;
  padding-top: 22px;
  border-top: 1px solid var(--rule);
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 14px;
  font-size: 0.95rem;
  color: var(--ink-muted);
  font-style: italic;

  a {
    color: var(--ink-soft);
    text-decoration: none;
    border-bottom: 1px solid var(--rule);
    padding: 6px 0 2px;
    font-style: normal;
  }
  a:hover { color: var(--accent); border-color: var(--accent); text-decoration: none; }

  .links { display: flex; gap: 4px 18px; flex-wrap: wrap; }
`;

function Contact() {
  return (
    <Section id="contact">
      <Eyebrow>vii — contact</Eyebrow>
      <SectionTitle>Get in touch.</SectionTitle>
      <Lede>
        Open to senior SWE and ML roles. Email is the fastest way to reach me.
      </Lede>
      <Email href="mailto:alihamza19999@gmail.com">alihamza19999@gmail.com</Email>

      <Footer>
        <div>© {new Date().getFullYear()} Ali Hamza · New York</div>
        <div className="links">
          <a href="https://github.com/hurryingauto3" target="_blank" rel="noopener noreferrer">github</a>
          <a href="https://www.linkedin.com/in/alihamza99/" target="_blank" rel="noopener noreferrer">linkedin</a>
          <a href="https://x.com/HurryingAuto3" target="_blank" rel="noopener noreferrer">twitter</a>
          <a href="https://www.reddit.com/user/hurryingauto3" target="_blank" rel="noopener noreferrer">reddit</a>
          <a href="https://letterboxd.com/hurryingauto3/" target="_blank" rel="noopener noreferrer">letterboxd</a>
          <a href="https://psnprofiles.com/HurryingAuto3" target="_blank" rel="noopener noreferrer">psn</a>
        </div>
      </Footer>
    </Section>
  );
}

export default Contact;
